import { MultiselectControl } from './multiselect.js';

/**** INIT ****/

const multiselects = document.querySelectorAll('.js-multiselect');

for (const multiselect of multiselects) {
    const instance = new MultiselectControl(multiselect);
    instance.init();
}